<script setup lang="ts">
import type { ProductPlan } from '~/config'

interface Props {
  plans: ProductPlan[]
  formLink: string
}

defineProps<Props>()
</script>

<template>
  <template v-if="!!plans?.length">
    <GridComponent
      :cols="3"
      :min-cols="1"
    >
      <template
        v-for="plan in plans"
        :key="plan.name"
      >
        <ContentProductPlanItem
          v-bind="plan"
          :form-links="formLink"
        />
      </template>
      <PvButton
        class="col-span-full w-full"
        as="a"
        @click="navigateTo(formLink, { external: true })"
      >
        <span class="py-2 text-xl font-bold uppercase md:text-2xl">Comprar ahora</span>
      </PvButton>
    </GridComponent>
  </template>
</template>
